import React, { useEffect } from 'react';
import { lang } from '@umu/ukit-lang';

import './index.scss';

interface IAglExpiryReminderData {
    popup_type: number;
    end_date_str: string;
}

interface IProps {
    data: IAglExpiryReminderData;
    onClose(): void;
    onShown?(): void;
}

const AglExpiryReminderDialog = (props: IProps) => {
    const { popup_type: popupType, end_date_str: endDateStr } = props.data;
    const isToday = Number(popupType) === 0;

    const title = isToday ? lang('AGL 服务今天到期') : lang('AGL 服务 {$0} 天后到期', popupType);

    const leftDayText = isToday ? lang('今天') : lang('{$0} 天后', popupType);

    const contentRows = [
        lang(
            '您好，您的 AGL 企业版服务到期日是 {$0}，将于{$1}到期，请尽快联系 UMU 客户经理续期。如果到期日前未完成续期，AGL 课程的创建、编辑、学习等功能将不可用。',
            endDateStr,
            leftDayText,
        ),
        lang('您也可以随时联系 UMU 客户经理进行沟通或续期。'),
    ];

    useEffect(() => {
        props.onShown?.();
    }, []);

    return (
        <div className="agl-expiry-reminder-dialog">
            <div className="agl-expire-title">{title}</div>
            <div className="agl-expire-content">
                {contentRows.map((row, index) => (
                    <p className="agl-expire-row" key={index}>
                        {row}
                    </p>
                ))}
            </div>
            <div className="agl-expire-footer">
                <div className="btn-confirm-text btn-text" onClick={props.onClose}>
                    {lang('知道了')}
                </div>
            </div>
        </div>
    );
};

export { IAglExpiryReminderData, AglExpiryReminderDialog };
